export default __webpack_public_path__ + "static/media/icon-email-inbound.c89bcc35.svg";